import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://rmldpazciopldqvzydbu.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtbGRwYXpjaW9wbGRxdnp5ZGJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYzNTIwMzgsImV4cCI6MjA5MTkyODAzOH0.bsanVoNG37nAe6VRM2Hjv3PMra_BM3vku6-uyTECFls';

const isConfigured =
  SUPABASE_URL !== 'YOUR_SUPABASE_URL' &&
  SUPABASE_ANON_KEY !== 'YOUR_SUPABASE_ANON_KEY' &&
  SUPABASE_URL.startsWith('https://');

const safeStub = {
  auth: {
    getSession:        () => Promise.resolve({ data: { session: null } }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
    signInWithPassword:() => Promise.resolve({ data: {}, error: { message: "Supabase not configured." } }),
    signUp:            () => Promise.resolve({ data: {}, error: { message: "Supabase not configured." } }),
    signOut:           () => Promise.resolve({}),
  },
  from: () => ({
    select:  () => ({ order: () => ({ limit: () => Promise.resolve({ data: [], error: null }) }), eq: () => Promise.resolve({ data: null, error: null }), single: () => Promise.resolve({ data: null, error: null }) }),
    insert:  () => ({ select: () => ({ single: () => Promise.resolve({ data: null, error: { message: "Supabase not configured." } }) }) }),
    update:  () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
    delete:  () => ({ eq: () => Promise.resolve({ data: null, error: null }) }),
    upsert:  () => Promise.resolve({ data: null, error: null }),
  }),
};

export const supabase = isConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  : safeStub;

export const isSupabaseConfigured = isConfigured;